import React, { useState } from "react";
import styles from "./inputs.module.scss";

export function SelectBtn(props) {
  const { check, children, onClick } = props;
  return (
    <div
      onClick={onClick}
      className={`${styles.sel_btn} ${
        check ? styles.sel_actived : styles.not_sel_actived
      }`}
    >
      {children}
    </div>
  );
}

export function SelectInput(props) {
  const {
    check,
    children,
    onClick,
    value = "",
    onChange = () => {},
    placeholder = "Other",
  } = props;
  return (
    <input
      type="text"
      placeholder={placeholder}
      onClick={onClick}
      value={value}
      onChange={onChange}
      className={`${styles.sel_btn} ${
        check ? styles.sel_actived : styles.not_sel_actived
      }`}
    >
      {children}
    </input>
  );
}

export function SelectAnswer(props) {
  const { data, onChange, name } = props;
  const { question, answers } = data;
  const [selected, setselected] = useState(-1);

  const [other, setother] = useState("");

  const handleChange = (e) => {
    setother(e.target.value);
    onChange(e.target.value, name);
  };

  const handle_select = (key) => {
    setselected(key);
    onChange(answers[key], name);
  };

  return (
    <div className={styles.select_answer}>
      <span className={styles.question}> {question} </span>
      <div className={styles.group}>
        {answers.map((item, key) => {
          // if (item === "Other") {
          //   return (
          //     <SelectInput
          //       key={key}
          //       value={other}
          //       onChange={handleChange}
          //       check={selected === key}
          //       placeholder="Other"
          //       onClick={() => handle_select(key)}
          //     />
          //   );
          // }
          return (
            <SelectBtn
              key={key}
              check={selected === key}
              onClick={() => handle_select(key)}
            >
              {item}
            </SelectBtn>
          );
        })}
      </div>
    </div>
  );
}
